<template>
  <div id="app">
    <!-- 页面切换动画transitionName -->
    <transition :name="transitionName">
      <!-- 缓存数据 <router-view> -->
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </transition>
    <transition :name="transitionName">
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </transition>
    <UserWatermark></UserWatermark>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      transitionName: ""
    }
  },
  watch: {
    $route(to, from) {
      if (to.meta.index > 0 && from.meta.index) {
        if (to.meta.index < from.meta.index) {
          this.transitionName = "slide-right";
        } else {
          this.transitionName = "slide-left";
        }
      } else if (to.meta.index == 0 && from.meta.index > 0) {
        this.transitionName = "";
      }
    }
  },
}
</script>

<style lang="scss">

</style>
